import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const sectionTracker = {
    init() {
        this.appendTrackerItems();
        this.trackScrollPosition();
    },
    appendTrackerItems() {
        const sectionTrackerElement = document.querySelector('.section-tracker__list');
        const sections = document.querySelectorAll('.files');
        let subCategoryList = []

        if (sections.length === 0 && !sectionTrackerElement) {
            return;
        }
        const trackerItems = [];
        sections.forEach(
            (item) => {
                const sectionID    = item.id;
                const sectionTitle = sectionTracker.getSectionTitle(item);
                const sectionItem  = sectionTracker.createNavigationItem(sectionID, sectionTitle);
                const sectionItems = item.querySelectorAll('.files-content');

                if (sectionItems.length > 0) {

                    subCategoryList = []

                    sectionItems.forEach( (subItem) => {
                        const subItemSectionID = subItem.id;

                        if (subItemSectionID) {
                            const subSectionTitle = sectionTracker.getSectionTitle(subItem);
                            const subSectionItem  = sectionTracker.createNavigationItem(subItemSectionID, subSectionTitle);
                            subCategoryList.push(subSectionItem)
                        }
                    } )
                    if (subCategoryList.length) {
                        subCategoryList = sectionTracker.createNavigationChildList(subCategoryList)
                    }

                }
                if( sectionID ) {
                    sectionItem.append(subCategoryList)
                    trackerItems.push(sectionItem);
                }

            },
        );

        sectionTracker.addItemsToContainerList(trackerItems);
    },
    getSectionTitle(section) {
        let sectionTitle = section.querySelectorAll('h1, h2, h3, h4, h5, h6');
        let headingText = null;
        if (sectionTitle.length === 0) {
            sectionTitle = section.id;
            if (!sectionTitle) {
                return 'Section';
            }
            return sectionTitle;
        }
        sectionTitle.forEach(
            (heading, index) => {
                if (index === 0) {
                    headingText = heading.innerText;
                }
            },
        );
        return headingText;
    },
    createNavigationItem(ID, title) {
        const listItem = document.createElement('li');
        const navigationItem = document.createElement('a');
        navigationItem.href = `#${ID}`;
        navigationItem.innerText = title;
        navigationItem.addEventListener('click', sectionTracker.clickBehaviour);
        listItem.append(navigationItem);
        return listItem;
    },
    createNavigationChildList(items) {
        const list = document.createElement('ul');
        items.forEach( (item) => {
            list.append(item);
        } )
        return list;

    },
    addItemsToContainerList(items) {
        const sectionTrackerElement = document.querySelector('.section-tracker__list');
        if (!sectionTrackerElement) {
            return;
        }
        items.forEach(
            (item) => {
                sectionTrackerElement.append(item);
            },
        );
    },
    clickBehaviour(item) {
        const parentItem = item.target.parentNode;
        parentItem.parentNode.querySelectorAll('li').forEach(
            (li) => {
                li.classList.remove('active');
            },
        );
        if (!parentItem.classList.contains('active')) {
            parentItem.classList.add('active');
        }
    },
    trackScrollPosition() {
        const sections = document.querySelectorAll('.files');
        const subSections = document.querySelectorAll('.files-content');

        gsap.registerPlugin(ScrollTrigger);
        document.addEventListener('wheel, touch', () => ScrollTrigger.update());

        sections.forEach((section) => {
            if (section.id) {
                ScrollTrigger.create({
                    trigger: `#${section.id}`,
                    start: 'top center',
                    end: 'bottom center',
                    markers: false,
                    onToggle: (self) => {
                        const currentActiveItem = document.querySelector(`.section-tracker__list a[href="#${section.id}"]`);
                        const parentCurrentActiveItem = currentActiveItem.parentNode;

                        if (self.isActive) {
                            parentCurrentActiveItem.classList.add('active');
                        } else {
                            parentCurrentActiveItem.classList.remove('active');
                        }
                    },
                });
            }

        });

        subSections.forEach((section) => {
            if ( section.id) {
                ScrollTrigger.create({
                    trigger: `#${section.id}`,
                    start: 'top center',
                    end: 'bottom center',
                    markers: false,
                    onToggle: (self) => {
                        const currentActiveItem = document.querySelector(`.section-tracker__list a[href="#${section.id}"]`);
                        const parentCurrentActiveItem = currentActiveItem.parentNode;

                        if (self.isActive) {
                            parentCurrentActiveItem.classList.add('active');
                        } else {
                            parentCurrentActiveItem.classList.remove('active');
                        }
                    },
                });
            }

        });
    },
};

export default sectionTracker;